import React, { useState, useEffect } from "react";
import ModalImage from "~components/Modal/ModalImage";
import useModalResponse from "~components/Modal/hooks/useModalResponse";
import useUsuario from "~fetchs/useUsuario";
import { podeEscolherFonte } from "../utils/dataSource";

const SMDataSourceButton = () => {
  const { isModalOpen, closeModal, openModal } = useModalResponse();
  const { usuario } = useUsuario();

  const [dataSource, setDataSource] = useState(
    () => localStorage.getItem("sm_data_source") ?? "mock"
  );

  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const onOnline = () => setIsOnline(true);
    const onOffline = () => setIsOnline(false);
    window.addEventListener("online", onOnline);
    window.addEventListener("offline", onOffline);
    return () => {
      window.removeEventListener("online", onOnline);
      window.removeEventListener("offline", onOffline);
    };
  }, []);

  const handleSelectSource = (source) => {
    if (source === dataSource) {
      closeModal();
      return;
    }
    localStorage.setItem("sm_data_source", source);
    closeModal();
    window.location.reload();
  };

  if (!podeEscolherFonte(usuario) || !isOnline) return null;

  return (
    <>
      <button
        type="button"
        onClick={openModal}
        className="fixed bottom-6 right-6 z-[1000] flex items-center gap-2 bg-[#01054C] text-white text-sm font-semibold px-4 py-2 rounded-full shadow-lg hover:bg-[#0a1a7a] transition"
      >
        <span
          className={`w-2 h-2 rounded-full ${
            dataSource === "api" ? "bg-green-400" : "bg-yellow-400"
          }`}
        />
        Fonte: {dataSource === "api" ? "API / Dexie" : "Mock"}
      </button>

      <ModalImage isOpen={isModalOpen} closeModal={closeModal}>
        <h3 className="text-xl font-bold text-[#01054C] mb-2">
          Fonte de Dados (QA)
        </h3>
        <p className="text-sm mb-6">
          Selecione de onde os dados do módulo de Gestão de Vendas serão
          carregados.
        </p>
        <div className="flex flex-col gap-3">
          <button
            type="button"
            onClick={() => handleSelectSource("mock")}
            className={`w-full py-3 rounded-lg font-semibold border-2 transition ${
              dataSource === "mock"
                ? "border-[#01054C] bg-[#01054C] text-white"
                : "border-[#01054C] text-[#01054C] hover:border-[#01054C]"
            }`}
          >
            Mock
          </button>
          <button
            type="button"
            onClick={() => handleSelectSource("api")}
            className={`w-full py-3 rounded-lg font-semibold border-2 transition ${
              dataSource === "api"
                ? "border-none bg-[#01054C] text-white"
                : "border-gray-300 text-gray-700 hover:border-green-600"
            }`}
          >
            API / Dexie
          </button>
        </div>
      </ModalImage>
    </>
  );
};

export default SMDataSourceButton;
